







































import {Vue, Component, Prop} from 'vue-property-decorator'
import TooltipMobileContent from '@/components/tooltip/TooltipMobileContent.vue'
import Tooltip from '@/components/tooltip/Tooltip.vue'

@Component({
  components: {Tooltip, TooltipMobileContent},
})
export default class SwapLockedAmount extends Vue {
  @Prop({type: String, required: true}) amount!: string
  @Prop({type: String, required: true}) amountInDollar!: string

  get amountFormatted() {
    if (!this.amount) {
      return '0.00'
    }

    if (this.amount.endsWith('.')) {
      return this.amount.slice(0, -1)
    } else {
      return this.amount
    }
  }
}
